"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _Header = _interopRequireDefault(require("../Header/Header"));

var _reactOlext_logo = _interopRequireDefault(require("../../../assets/images/react-olext_logo.svg"));

var _CurrentCoordinateText = _interopRequireDefault(require("../../text/coordinate/CurrentCoordinateText/CurrentCoordinateText"));

var _CurrentScaleText = _interopRequireDefault(require("../../text/scale/CurrentScaleText/CurrentScaleText"));

var _useWindowSize2 = _interopRequireDefault(require("../../../hooks/ui/useWindowSize"));

var _deviceUnits = require("../../../core/deviceUnits");

var _constants = require("../../../core/constants");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "style", "logo", "mainTitle", "subTitle", "breakpoint"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * <p>
 *  A simple Header for the application with a logo, title, subtitle, 
 *  current coordinate and current scale
 * </p>
 * <p>
 *  To build a custom header, check the <i>Header</i> component.
 * </p>
 *
 */
var SimpleHeader = function SimpleHeader(_ref) {
  var map = _ref.map,
      style = _ref.style,
      _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? _reactOlext_logo.default : _ref$logo,
      _ref$mainTitle = _ref.mainTitle,
      mainTitle = _ref$mainTitle === void 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
    href: _constants.API_DOC_LINK,
    target: "_blank",
    rel: "noopener noreferrer",
    title: "React-Olext API Doc",
    children: "React-Olext"
  }) : _ref$mainTitle,
      _ref$subTitle = _ref.subTitle,
      subTitle = _ref$subTitle === void 0 ? 'Components for OpenLayers' : _ref$subTitle,
      _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? (0, _deviceUnits.convertRemToPixels)(40) : _ref$breakpoint,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useWindowSize = (0, _useWindowSize2.default)(),
      width = _useWindowSize.width;

  var logoHeight = style && style.height ? style.height : undefined;
  var styleMainTitle = width <= breakpoint ? {
    fontSize: '1.5rem'
  } : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Header.default, _objectSpread(_objectSpread({
    style: style
  }, otherProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default.Logo, {
      logo: logo,
      height: logoHeight
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Header.default.Title, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default.Title.MainTitle, {
        style: styleMainTitle,
        children: mainTitle
      }), width > breakpoint && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default.Title.SubTitle, {
        children: subTitle
      })]
    }), width > breakpoint && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Header.default.Content, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "rolext-header-content-label",
        children: "Pos:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentCoordinateText.default, {
        map: map,
        className: "rolext-header-content-value",
        style: {
          width: "10rem"
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "rolext-header-content-label",
        children: "Scale: 1/"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentScaleText.default, {
        map: map,
        className: "rolext-header-content-value",
        style: {
          width: "4rem"
        }
      })]
    })]
  }));
};

SimpleHeader.propTypes = {
  /**
   * The OpenLayers ol/Map
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * The logo to be shown in the Header.
   * The default is the React-Olext Logo in
   * SVG format.
   */
  logo: _propTypes.default.any,

  /**
   * A CSS Style to render the Header
   */
  style: _propTypes.default.object,

  /**
   * The main title to be shown in the Header
   */
  mainTitle: _propTypes.default.node,

  /**
   * The subtitle to be shown in the Header
   */
  subTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * If the window size is less than or equal to the breakpoint, 
   * the header will not show the content (position and scale)
   */
  breakpoint: _propTypes.default.number
};
var _default = SimpleHeader;
exports.default = _default;